import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// PrimeVue
import PrimeVue from 'primevue/config'
import 'primevue/resources/themes/lara-light-blue/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'

// Estilos globales
import './assets/global.css'

// PrimeVue Components
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Password from 'primevue/password'
import Toast from 'primevue/toast'
import ToastService from 'primevue/toastservice'
import Card from 'primevue/card'
import FileUpload from 'primevue/fileupload'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from 'primevue/dialog'
import ProgressSpinner from 'primevue/progressspinner'
import Dropdown from 'primevue/dropdown'

const app = createApp(App)

// Usar plugins
app.use(store)
app.use(router)
app.use(PrimeVue)
app.use(ToastService)

// Registrar componentes globalmente
app.component('Button', Button)
app.component('InputText', InputText)
app.component('Password', Password)
app.component('Toast', Toast)
app.component('Card', Card)
app.component('FileUpload', FileUpload)
app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('Dialog', Dialog)
app.component('ProgressSpinner', ProgressSpinner)
app.component('Dropdown', Dropdown)

app.mount('#app') 